import { render } from "./PickDropZone.vue?vue&type=template&id=7ec62ea6&scoped=true"
import script from "./PickDropZone.vue?vue&type=script&lang=ts"
export * from "./PickDropZone.vue?vue&type=script&lang=ts"

import "./PickDropZone.vue?vue&type=style&index=0&id=7ec62ea6&lang=less&scoped=true"
import "./PickDropZone.vue?vue&type=style&index=1&id=7ec62ea6&lang=css"
script.render = render
script.__scopeId = "data-v-7ec62ea6"

export default script